import { Check } from 'lucide-react'

import { cn } from '../../../../lib/utils'

export const CLAIM_STEPS = [
  'Upload Photos',
  'Truck & Driver',
  'Incident Details',
  'Others Involved',
  'Review & Submit',
] as const

type StepState = 'active' | 'completed' | 'locked'

interface ClaimStepperProps {
  activeStep: number // 1-based
  completedSteps: number[]
  /** Another wizard's step names; the claim's by default. */
  steps?: readonly string[]
}

export function ClaimStepper({ activeStep, completedSteps, steps = CLAIM_STEPS }: ClaimStepperProps) {
  function stateFor(step: number): StepState {
    if (completedSteps.includes(step)) return 'completed'
    if (step === activeStep) return 'active'
    return 'locked'
  }

  // Horizontal tab strip on mobile; vertical rail (like the insurance application) on desktop.
  return (
    <ol className="flex items-center gap-4 overflow-x-auto px-2 py-3 md:flex-col md:items-start md:gap-8 md:overflow-visible md:px-0 md:py-0">
      {steps.map((title, i) => {
        const step = i + 1
        const state = stateFor(step)
        return (
          <li
            key={title}
            data-state={state}
            className={cn(
              'flex shrink-0 items-center gap-2 px-3 py-3 text-sm md:px-0 md:py-0',
              state === 'active' &&
                'border-b-primary border-b-2 font-semibold text-neutral-900 md:border-b-0',
              state === 'completed' && 'text-neutral-900',
              state === 'locked' && 'text-neutral-400'
            )}
          >
            <span
              className={cn(
                'line-height-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs',
                (state === 'active' || state === 'completed') &&
                  'border-primary bg-primary text-primary-foreground',
                state === 'locked' && 'border-neutral-300'
              )}
            >
              {state === 'completed' ? <Check className="h-3 w-3" /> : step}
            </span>
            <span className="whitespace-nowrap">{title}</span>
          </li>
        )
      })}
    </ol>
  )
}
